import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ServerUnavailableOverlay } from "@/components/ServerUnavailableOverlay";
import { API_BASE } from "@/lib/api";
import { RequireShopAuth } from "@/components/RequireShopAuth";
import { RequirePermanentContract } from "@/components/RequirePermanentContract";
import { LoginPage } from "@/pages/LoginPage";
import { CatalogPage } from "@/pages/CatalogPage";
import { CartPage } from "@/pages/CartPage";
import { CheckoutPage } from "@/pages/CheckoutPage";
import { CheckoutSuccessPage } from "@/pages/CheckoutSuccessPage";
import { VisitorPage } from "@/pages/VisitorPage";
import { loadShopSession } from "@/lib/shopAuth";

function HomeRedirect() {
  const session = loadShopSession();
  return <Navigate to={session ? "/" : "/login"} replace />;
}

export function App() {
  return (
    <BrowserRouter>
      <ServerUnavailableOverlay apiBase={API_BASE} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireShopAuth />}>
          <Route path="/" element={<CatalogPage />} />
          <Route path="/warenkorb" element={<CartPage />} />
          <Route path="/kasse" element={<CheckoutPage />} />
          <Route path="/kasse/erfolg" element={<CheckoutSuccessPage />} />
          <Route element={<RequirePermanentContract />}>
            <Route path="/besucher" element={<VisitorPage />} />
          </Route>
        </Route>
        <Route path="*" element={<HomeRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}
